<!-- 报警开关按钮  点击弹出报警开关对话框 -->

<template>
    <span>
        <i :class='`driver-item-alarm-switch bolder iconfont icon-baojing cursor-pointer ${iconColor}`'
           :title='iconDesc' @click='showAlarmSwitch'></i>
    </span>
</template>

<script>
import bus from '@/utils/bus'

export default {
  props: {
    // 挂载信息 包括id  keycode
    alarmSwitch: {
      default: 0
    },
    carrierIds: {},
    triggerIds: {},
    sceneId: {},
    carrierType: {},
    // 是否关联 关联后才能点击 未关联显示灰色不能点击
    related: {
      type: Number
    },
    // 刷新列表函数
    getList: {}
  },
  computed: {
    iconDesc () {
      if (this.related) {
        if (this.carrierIds) {
          return $t('public.alarm_switch')
        } else {
          return this.alarmSwitch ? $t('public.trigger_on') : $t('public.trigger_off') 
        }
      } else {
        return $t('public.unrelated_trigger') 
      }
    },
    iconColor () {
      // 未关联显示灰色
      if (!this.related) return 'color-gray'
      if (this.alarmSwitch) {
        return 'color-green'
      }// 关联 但是未开启显示红色
      else {
        return 'color-red'
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    showAlarmSwitch () {
      if (this.related) {
        bus.$emit('alarmSwitchDialog', {
          event: this.alarmSwitch,
          triggerIds: this.triggerIds,
          carrierIds: this.carrierIds,
          sceneId: this.sceneId,
          type: this.carrierType,
          getList: this.getList
        })
      }
    }
  }
}
</script>
